<template>
  <VeeField
    v-if="useCartFormData().value.invoiceAddress != null"
    v-slot="{ field, meta, errors }"
    v-model="useCartFormData().value.invoiceAddress!.telephone"
    name="telephone"
    :rules="
      (function () {
        let required = false;
        bins?.forEach((bin: { phoneRequired: any; }) => {
          if (bin.phoneRequired) required = true;
        });
        return required && !optional ? 'required|phone' : 'phone';
      })()
    "
  >
    <div :class="meta.touched ? (meta.valid ? 'valid' : 'invalid') : ''">
      <input
        v-bind="field"
        :class="inputClass"
        type="text"
        :placeholder="
          (function () {
            let required = false;
            bins?.forEach((bin: { phoneRequired: any; }) => {
              if (bin.phoneRequired) required = true;
            });
            return 'Telefonnummer' + (required && !optional ? '*' : '');
          })()
        "
      >
    </div>
    <span>{{ errors[0] }}</span>
    <div
      v-if="
        !isReservation &&
        !optional &&
        (function () {
          let required = false;
          bins?.forEach((bin: { phoneRequired: any; }) => {
            if (bin.phoneRequired) required = true;
          });
          return required;
        })()
      "
      class="py-4 text-xs text-paragraph-light"
    >
      Bitte geben Sie Ihre Telefonnummer an, damit das Speditionsunternehmen mit Ihnen
      einen Liefertermin vereinbaren kann.
    </div>
  </VeeField>
</template>
<script setup lang="ts">
import { useCartFormData } from "~/composables/states";
type InputClass = string;
defineProps({
  isReservation: {
    type: Boolean,
    default: () => {
      return inject("isReservation");
    },
  },
  inputClass: {
    type: String as PropType<InputClass>,
    default: "inp sm",
  },
  bins: {
    type: Object,
    default: null,
  },
  optional: {
    type: Boolean,
    default: false,
  },
});
useLibPhoneValidation();
</script>
